import { Box, Grid, Stack, Typography, useMediaQuery } from '@mui/material'
import React, { useContext } from 'react'
import {motion} from 'framer-motion';
import { ThemeContext } from '../Context/ThemeContext';

function TechStack() {
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const {mode} = useContext(ThemeContext);
    const images = [
        {src: "https://upload.wikimedia.org/wikipedia/commons/6/61/HTML5_logo_and_wordmark.svg", width: 120, height: 130, alt: "html"},
        {src: "https://upload.wikimedia.org/wikipedia/commons/d/d5/CSS3_logo_and_wordmark.svg", width: 100, height: 120, alt: "css"},
        {src: "https://i0.wp.com/theicom.org/wp-content/uploads/2016/03/js-logo.png", width: 100, height: 120, alt: "js"},
        {src: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg", width: 100, height: 120, alt: "react"},
        {src: "https://cdn.zapier.com/storage/blog/4ec8fc7dc3a75758a3913bab9e5a4fd8_2.500x278.png", width: 100, height: 120, alt: "redux"},
        {src: "https://mui.com/static/logo.png", width: 100, height: 120, alt: "mui"},
        {src: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Node.js_logo.svg", width: 100, height: 120, alt: "nodejs"},
        {src: "https://youteam.io/blog/wp-content/uploads/2022/04/expressjs_logo.png", width: 160, height: 120, alt: "express"},
        {src: mode ? "https://e1.pxfuel.com/desktop-wallpaper/285/342/desktop-wallpaper-https-eladnava-get-mongodb-thumbnail.jpg" : "https://upload.wikimedia.org/wikipedia/commons/9/93/MongoDB_Logo.svg", width: 100, height: 120, alt: "mongodb"},
        {src: "https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2Fmeta-l.cdn.bubble.io%2Ff1678214001507x239515035225292830%2F1_ti5CnGh_T4Kqy5aCTLJRcg.png", width: 100, height: 120, alt: "firebase"},
        {src: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Visual_Studio_Code_1.35_icon.svg", width: 100, height: 120, alt: "vscode"},
        {src: mode ? "https://static-00.iconduck.com/assets.00/github-icon-2048x1988-jzvzcf2t.png" : "https://upload.wikimedia.org/wikipedia/commons/9/91/Octicons-mark-github.svg", width: 100, height: 120, alt: "github"},
    ]
  return (
    <Box component={"div"} id='techstack' py={5}>
        <Typography variant='h3' sx={{ fontWeight: "700" }} textAlign="center" width={300} borderBottom="1px solid" borderColor={"primary"} color="primary" m="auto" mb={5}>Tech Stack</Typography>
        <Grid container direction={"row"} justifyContent={"space-between"} px={isSmallScreen ? 2 : 10} rowGap={{ xs: 0, lg: 5 }}>
            {
                images.map((image, index)=>(
                    <>
                        {
                            image.alt === "react" ? 
                            <motion.img item src={image.src}
                            alt={image.alt} 
                            width={image.width} 
                            height={image.height}  key={index} lg={2} xs={4} p={2} sx={{ objectFit: "contain" }}
                            animate={{
                                rotate: 360,
                            }}
                            transition={{
                                duration: 1,
                                ease: 'linear',
                                repeat: Infinity,
                            }}
                            >
                            </motion.img>
                             : 
                            <Grid item component={"img"} src={image.src} alt={image.alt} width={image.width} height={image.height} key={index} lg={2} xs={4} p={2} sx={{ objectFit: "contain" }} />
                        }
                    </>
                ))
            }
        </Grid>
    </Box>
  )
}

export default TechStack